import { Component } from "react"
import PropTypes from "prop-types"
import { compactInteger } from "humanize-plus"
import userIconPng from "images/web/applet_card/user-icon.png"
import appletOrConnection from "shared/lib/use_applet_or_connection"
import proPlusBadge from "images/plan-badges/pro_plus.svg"
import proBadge from "images/plan-badges/pro.svg"

export default class Meta extends Component {
  render() {
    const { applet } = this.props
    const humanizedInstallNumber = compactInteger(applet.installs_count, 1)
    const appletType = appletOrConnection(applet)
    const needsProBadge = applet.pro_features || applet.intermediate_pro_features

    return (
      <div className="meta">
        {applet.installs_count > 0 && (
          <div
            className="installs"
            aria-label={`${humanizedInstallNumber} users`}
            title={`${humanizedInstallNumber} users enabled this ${appletType}`}
          >
            <span className="verified">
              <img src={userIconPng} alt="user icon" loading="lazy" width="14" height="18" />
            </span>
            <span>{humanizedInstallNumber}</span>
          </div>
        )}
        {needsProBadge && (
          <span
            title={`Applet has pro features`}
            className="card-badge"
            dangerouslySetInnerHTML={{
              __html: applet.pro_features ? proPlusBadge : proBadge,
            }}
          />
        )}
      </div>
    )
  }
}

Meta.propTypes = {
  applet: PropTypes.object.isRequired,
  uniquePermissions: PropTypes.array,
}
